/*
 * Diagrams for the three onboarding steps on the Getting live screen (mockup
 * 23.47.40): sources (LIS / HIS and file drop; API removed 2026-10-24) wired into a mapping hub, a report page being configured,
 * and a stack of tested pages. Always visible and decorative; the checklists
 * beside them carry the content.
 */
import { FileText } from 'lucide-react';
import { CheckDiscGlyph } from '../mocks/ProductGlyphs';
import { BrandMark } from '../mocks/ReportCover';
import { MountainLake } from '../mocks/Scenery';
import { CogGlyph, DatabaseGlyph } from '../mocks/TileGlyphs';
import './LiveDiagrams.css';

const SOURCES = [
  { key: 'lis', Glyph: DatabaseGlyph, tone: 'purple', label: 'LIS / HIS' },
  { key: 'file', Glyph: FileText, tone: 'navy', label: 'File Drop' },
];

export function IntegrateDiagram() {
  return (
    <div className="gld gld--integrate" aria-hidden="true">
      <ul className="gld-sources">
        {SOURCES.map(({ key, Glyph, tone, label }) => (
          <li key={key}>
            <Glyph size={20} strokeWidth={2} className={`gld-tone--${tone}`} />
            {label}
          </li>
        ))}
      </ul>
      <span className="gld-hubzone">
        <svg className="gld-wires" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true" focusable="false">
          <g fill="none" stroke="#a9c2ee" strokeWidth="1.4" strokeDasharray="4 4" vectorEffect="non-scaling-stroke">
            <path d="M0 27C22 27 18 50 42 50" vectorEffect="non-scaling-stroke" />
            <path d="M0 73C22 73 18 50 42 50" vectorEffect="non-scaling-stroke" />
            <path d="M58 50C80 50 76 12 100 12" vectorEffect="non-scaling-stroke" />
            <path d="M58 50C80 50 80 88 100 88" vectorEffect="non-scaling-stroke" />
            <path d="M50 64V100" vectorEffect="non-scaling-stroke" />
          </g>
        </svg>
        <span className="gld-hub">
          <CogGlyph size={40} />
        </span>
      </span>
    </div>
  );
}

function Lines({ n = 3, className = '' }) {
  return (
    <span className={`gld-lines ${className}`}>
      {Array.from({ length: n }, (_, i) => (
        <i key={`l-${i}`} />
      ))}
    </span>
  );
}

export function BuildDiagram() {
  return (
    <div className="gld gld--build" aria-hidden="true">
      <span className="gld-page gld-page--back" />
      <span className="gld-page gld-page--front">
        <span className="gld-page__head">
          <BrandMark className="gld-mark" />
          <Lines n={2} className="gld-lines--right" />
        </span>
        <span className="gld-page__split">
          <Lines n={4} />
          <MountainLake className="gld-lake" />
        </span>
        <Lines n={3} />
        <span className="gld-page__split gld-page__split--foot">
          <span className="gld-thumb" />
          <Lines n={3} />
        </span>
      </span>
    </div>
  );
}

export function TestDiagram() {
  return (
    <div className="gld gld--test" aria-hidden="true">
      <span className="gld-page gld-page--stack3" />
      <span className="gld-page gld-page--stack2" />
      <span className="gld-page gld-page--front">
        <span className="gld-page__head">
          <BrandMark className="gld-mark" />
          <Lines n={2} className="gld-lines--right" />
        </span>
        <Lines n={2} />
        <span className="gld-checks">
          <span className="gld-checkrow">
            <i />
            <span className="gld-checkcard">
              <CheckDiscGlyph size={20} color="#1463f3" />
            </span>
            <i />
          </span>
          <span className="gld-checkrow">
            <i />
            <span className="gld-checkcard">
              <CheckDiscGlyph size={20} color="#16955a" />
            </span>
            <i />
          </span>
        </span>
        <Lines n={3} />
      </span>
    </div>
  );
}
